import plur from "plur";
import { Banner, LoadingIndicator, Text } from "@jsq/ds/core";
import { withClientContext } from "~/apollo/client";
import { useGetCurrentUserQuery } from "~/graphql/mainHooks";
import * as styles from "~/pages/FundAccounting/Entities/components/TransferWarningBanner/styles_vanilla.css";
import { SPACING } from "~/styles/variables";
import { isTransferSyncUser } from "~/utils/userRoles";

type Props = {
  transferCount: number;
  onViewDetails: () => void;
  onSyncTransfer: () => void;
};

const REGULAR_DESCRIPTION = `They will be synced if they fall within your selected date range. `;
const NO_PERMISSION_DESCRIPTION = `You do not have permission to sync transfers. If you’d like to sync all transfers first, reach out to the FA team for assistance. `;

const TransferBanner = (props: Props) => {
  const { data: userData, loading } = useGetCurrentUserQuery({
    context: withClientContext("staff"),
  });
  if (loading) {
    return <LoadingIndicator variant="primary" />;
  }
  const roles: string[] =
    userData?.currentUser?.roles?.edges
      .map((edge) => edge.node.name)
      .filter((name): name is string => !!name) || [];
  const allowSync = isTransferSyncUser(roles);

  const bannerDescription = (
    <Text style={{ maxWidth: "700px" }}>
      {allowSync ? REGULAR_DESCRIPTION : NO_PERMISSION_DESCRIPTION}
      <button
        className={styles.ViewAll}
        onClick={() => {
          props.onViewDetails();
        }}
      >
        View transfer details
      </button>
    </Text>
  );
  return (
    <Banner
      variant="warning"
      title={`${props.transferCount} transfer ${plur("event", props.transferCount)} exist for this entity`}
      description={bannerDescription}
      style={{ marginBottom: SPACING.LARGE }}
      buttonProps={{
        children: "Sync only transfers",
        variant: "neutral",
        onClick: allowSync
          ? () => {
              props.onSyncTransfer();
            }
          : undefined,
      }}
    />
  );
};

export default TransferBanner;
